import { createSelector } from 'reselect';
import { State, AppointmentTypesState } from 'types';
import { AppointmentType } from 'EntityTypes';

type GetAppointmentTypeProps = {
  appointmentTypeId: number;
};
export const getAppointmentType = (
  state: State,
  { appointmentTypeId }: GetAppointmentTypeProps,
): AppointmentType =>
  state.entities.appointmentTypes ? state.entities.appointmentTypes[appointmentTypeId] : undefined;

export const getAppointmentTypeForUrl = createSelector(
  (state: State): AppointmentTypesState => state.entities.appointmentTypes,
  (_state: State, props: { appointmentTypeUrl: string }): string => props.appointmentTypeUrl,
  (appointmentTypes: AppointmentTypesState, appointmentTypeUrl: string): AppointmentType => {
    if (!(appointmentTypes && appointmentTypeUrl)) {
      return undefined;
    }

    return Object.values(appointmentTypes).find(
      (appointmentType): boolean => appointmentType.urlPath === appointmentTypeUrl,
    );
  },
);

export const getAppointmentTypes = createSelector(
  (state: State): AppointmentTypesState | undefined => state.entities.appointmentTypes,
  (appointmentTypesById) => {
    if (!appointmentTypesById) return undefined;
    return Object.values(appointmentTypesById).filter(
      (appointmentType) => appointmentType.patientBookable,
    );
  },
);
